import { EVENT_END_MINUTES, EVENT_START_MINUTES, minutesToTime } from "./slots";

export const UPCOMING_SLOT_LIMIT = 6;

/**
 * Upcoming slots for the info board: starts one step before `now` (floored to the step grid),
 * never before 15:00 and never past the last slot of the event. Break slots (`excludeMinute`)
 * are skipped, and at most `limit` slots are returned.
 */
export const generateUpcomingSlots = (now, stepMinutes, excludeMinute, limit = UPCOMING_SLOT_LIMIT) => {
  const nowMinutes = now.getHours() * 60 + now.getMinutes();
  let cursor = Math.floor((nowMinutes - stepMinutes) / stepMinutes) * stepMinutes;
  cursor = Math.max(cursor, EVENT_START_MINUTES);

  const slots = [];
  while (cursor < EVENT_END_MINUTES && slots.length < limit) {
    if (cursor % 60 !== excludeMinute) slots.push(minutesToTime(cursor));
    cursor += stepMinutes;
  }
  return slots;
};

const normalizeTime = (value) => String(value || "").substring(0, 5);

/** True when a scan row exists for this team at this time in this activity table. */
export const isTeamScanned = (scannedRows, team, time, tableNumber) =>
  scannedRows.some(
    (scan) =>
      normalizeTime(scan.time_slot) === normalizeTime(time) &&
      Number(scan.table) === Number(tableNumber) &&
      String(scan.team_name || "").toLowerCase() === String(team.team_name || "").toLowerCase()
  );

const EMPTY_CAPACITY = { current_capacity: 0, max_capacity: 0 };

/**
 * Combine the slot list with the availability API payload and the scan log into board rows:
 * `{ time, teams: [{ team_name, team_number, scanned }], capacityInfo }`.
 */
export const buildBoardColumn = (slotTimes, availabilityData, scannedRows, tableNumber) =>
  slotTimes.map((time) => ({
    time,
    teams: (availabilityData?.team_names?.[time] || []).map((team) => ({
      ...team,
      scanned: isTeamScanned(scannedRows, team, time, tableNumber),
    })),
    capacityInfo: availabilityData?.capacity_info?.[time] || EMPTY_CAPACITY,
  }));
